const clientsServedOptions = [
  "1-10 clients",
  "11-25 clients",
  "26+ clients"
]

const marketingTypeOptions = [
  "Full-Service Marketing",
  "SEO",
  "Content/Inbound Marketing",
  "Website Creation",
  "Other"
]

const referenceOptions = [
  "Google Search / Other search engine",
  "Word of Mouth / Referral",
  "A Verblio Partner (HubSpot, 99Designs, etc)",
  "I met someone from Verblio at an event",
  "I'm a returning customer",
  "Other"
]

const estimatedMonthlyBudgetOptions = [
  '$0-$499',
  '$500-$999',
  '$1,000-$4,999',
  '$5,000-$9,999',
  '$10,000-$14,999',
  '$15,000-$24,999',
  '$25,000+',
]
export { clientsServedOptions, marketingTypeOptions, referenceOptions, estimatedMonthlyBudgetOptions }
